
angular.module('bmsApp.directives').controller('NoteFormCtrl', ['$scope', '$log', '$timeout', '$q', '$modalInstance', '$ngBootbox', 'NoteSvc', 'FileSvc', 'note', '$window', function ($scope, $log, $timeout, $q, $modalInstance, $ngBootbox, NoteSvc, FileSvc, note, $window) {

		$scope.note = note;

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

		$scope.init = function () {
			$scope.processing = false;
			var noteTypeOptionsPromise = NoteSvc.noteTypeOptions();
			var promises = [noteTypeOptionsPromise];
			$q.all(promises)
				.then(function (responses) {
					$scope.noteTypeOptions = responses[0].data.options;
					$scope.note.uploaded_attachments = [];
					$scope.note.removed_attachments = [];
					$scope.enableSubmit = true;
				});
		};

		$scope.submit = function () {
			$scope.processing = true;

			var modalResult = {
				success: false
			};
			
			var savePromise = $scope.note.id ? NoteSvc.update($scope.note) : NoteSvc.create($scope.note);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = $scope.note.id ? 'update' : 'create';
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit();
			},
			errorPlacement: function (error, element) {
				error.appendTo('#note-errors');
			},
			errorContainer: '#note-errors'
		};

		$scope.dropzone = {
			config: {
				url: '/api/file/upload',
				parallelUploads: 3,
				maxFileSize: 30,
				addRemoveLinks: true,
				eventHandlers: {
					success: function (file, response) {
						file.serverFilepath = response.filepath;
						$scope.note.removed_attachments = _.without($scope.note.removed_attachments, file.serverFilepath);
						if (!_.contains($scope.note.uploaded_attachments, file.serverFilepath)) {
							$scope.note.uploaded_attachments.push(file.serverFilepath);
						}
						$timeout(function () {
							$scope.$apply();
						}, 0);
					},
					drop: function (event) {
						$scope.enableSubmit = false;
						$timeout(function () {
							$scope.$apply();
						}, 0);
					},
					queuecomplete: function () {
						$scope.enableSubmit = true;
						$timeout(function () {
							$scope.$apply();
						}, 0);
					},
					removedfile: function (file) {
						FileSvc.delete(file.serverFilepath)
							.then(function (response) {
								$scope.note.uploaded_attachments = _.without($scope.note.uploaded_attachments, file.serverFilepath);
								if (!_.contains($scope.note.removed_attachments, file.serverFilepath)) {
									$scope.note.removed_attachments.push(file.serverFilepath);
								}
								$log.log('Dropzone file removed');
							}, function (error) {
								$log.error('Failed to remove dropzone file: ' + error);
							});
					}
				}
			}
		};

		$scope.toggleDeleteNoteAttachment = function (note_attachment) {
			note_attachment.delete = note_attachment.delete ? false : true;
		};

		$scope.downloadAttachment = function(filename) {
			$window.open('file/download/'+filename, '_blank');
		}

	}]);
